const tagAdjectives = [
  "Amazing",
  "Attractive",
  "Beautiful",
  "Bright",
  "Cheerful",
  "Crazy",
  "Dreamy",
  "Efficient",
  "Epic",
  "Excellent",
  "Excited",
  "Fabulous",
  "Fair",
  "Fantastic",
  "Glad",
  "Golden",
  "Good",
  "Great",
  "Happy",
  "Hot",
  "Incredible",
  "Interesting",
  "Industrious",
  "Immortal",
  "Joyful",
  "Light",
  "Loud",
  "Lovely",
  "Lovey-dovey",
  "Lucky",
  "Luminous",
  "Magnificent",
  "Nice",
  "Optimistic",
  "Particular",
  "Perfect",
  "Pleasant",
  "Positive",
  "Pretty",
  "Profitable",
  "Pungent",
  "Rich",
  "Robust",
  "Skillful",
  "Sharp-witted",
  "Strong",
  "Superior",
  "Surprising",
  "Talented",
  "Terrific",
  "The best",
  "Unbelievable",
  "Vigorous",
  "Well-to-do",
  "Wise",
  "Wonderful",
];

export default tagAdjectives;
